import type {AnalyticsEvent} from '@github-ui/use-analytics'

export const CATEGORY = 'FEATURE_PREVIEW'

export interface FeaturePreviewAnalyticsPayload {
  action: string
  label: string
}

export function createEvent(config: FeaturePreviewAnalyticsPayload): AnalyticsEvent {
  return {
    category: CATEGORY,
    ...config,
  }
}
